import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTo";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import loadShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTo";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { AddOrUpdateShipTo, chain, LoadCart, UpdateBillTo } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateCart";
import { BaseAddressModel } from "@insite/client-framework/Types/ApiModels";
import { checkoutOption, dispatchCheckoutEvent } from "@store/Services/AnalyticsService";
import { createShipTo, updateBillTo, updateShipTo } from "@store/Services/CustomersService"; // Poolcorp Custom Code

function areAddressesTheSame(address1: BaseAddressModel, address2: BaseAddressModel) {
    return (
        address1.firstName === address2.firstName &&
        address1.lastName === address2.lastName &&
        address1.attention === address2.attention &&
        address1.companyName === address2.companyName &&
        address1.address1 === address2.address1 &&
        address1.address2 === address2.address2 &&
        address1.address3 === address2.address3 &&
        address1.address4 === address2.address4 &&
        address1.country?.id === address2.country?.id &&
        address1.city === address2.city &&
        address1.state?.id === address2.state?.id &&
        address1.postalCode === address2.postalCode &&
        address1.phone === address2.phone &&
        address1.email === address2.email &&
        address1.fax === address2.fax
    );
}

addToChainAfter(chain, LoadCart, props => {
    dispatchCheckoutEvent(2, checkoutOption.reviewOrder, props.apiParameter.cart);
});

replaceInChain(chain, AddOrUpdateShipTo, async props => {
    const { dispatch, getState, cart } = props;
    const state = getState();
    const {
        pages: {
            checkoutShipping: { shippingAddressFormState },
        },
    } = state;

    if (!shippingAddressFormState) {
        return;
    }

    const shipTo = getShipToState(state, cart.shipToId).value;
    const billTo = getBillToState(state, cart.billToId).value;
    if (!shipTo || !billTo) {
        throw new Error("There was no shipTo or billTo loaded for the current cart");
    }

    const { address: localModifiedShipTo } = shippingAddressFormState;

    if (!areAddressesTheSame(shipTo, localModifiedShipTo)) {
        props.updatedShipTo = localModifiedShipTo.isNew
            ? await createShipTo({ shipTo: localModifiedShipTo }) // Poolcorp Custom Import
            : await updateShipTo({ shipTo: localModifiedShipTo, billToId: billTo.id }); // Poolcorp Custom Import

        dispatch(loadShipTo({ shipToId: props.updatedShipTo.id, billToId: billTo.id }));

        props.apiParameter.cart.shipToId = props.updatedShipTo.id;
    }
});

replaceInChain(chain, UpdateBillTo, async props => {
    const { dispatch, getState, cart } = props;
    const state = getState();
    const {
        pages: {
            checkoutShipping: { billingAddressFormState },
        },
    } = state;
    if (!billingAddressFormState) {
        return;
    }

    const billTo = getBillToState(state, cart.billToId).value;
    if (!billTo) {
        throw new Error("There was no shipTo or billTo loaded for the current cart");
    }

    const { address: localModifiedBillTo } = billingAddressFormState;

    if (!areAddressesTheSame(billTo, localModifiedBillTo)) {
        props.updatedBillTo = await updateBillTo({ // Poolcorp Custom Import
            billTo: localModifiedBillTo,
            isEdit: true,
        });

        dispatch(loadBillTo({ billToId: billTo.id }));
        if (cart.shipToId === billTo.id) {
            dispatch(loadShipTo({ shipToId: cart.shipToId, billToId: billTo.id }));
        }

        props.apiParameter.cart.billToId = props.updatedBillTo.id;
    }
});

replaceInChain(chain, LoadCart, async props => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutShipping;
    /* Abolunet Custom Code - wait for loadCart */
    let result;
    if (cartId) {
        result = await loadCart({ cartId });
    } else {
        result = await loadCurrentCart({ getPromotions: true });
    }
    props.dispatch(result);
    /* Abolunet Custom Code */
});